// import React, { useState, useEffect } from "react";
// import Multiselect from "multiselect-react-dropdown";

// const MultiSelectDropdown = ({
//   options = [],
//   displayValue = "value",
//   placeholder = "Select options",
//   showCheckbox = true,
//   handleChange,
//   label,
//   required,
//   onBlur,
//   errorMessage,
//   isClearable = false,
//   selectedValue,
// }) => {
//   const [selectedValues, setSelectedValues] = useState(selectedValue || []);

//   // ✅ Sync selectedValue from parent on update (edit mode fix)
//   useEffect(() => {
//     setSelectedValues(selectedValue || []);
//   }, [selectedValue]);

//   useEffect(() => {
//     handleChange([]);
//   }, [isClearable]);

//   const handleSelectAllToggle = () => {
//     if (selectedValues.length === options.length) {
//       handleChange([]);
//     } else {
//       setSelectedValues(options);
//       handleChange(options);
//     }
//   };

//   const handleSelect = (selectedList) => {
//     setSelectedValues(selectedList);
//     handleChange(selectedList);
//   };

//   const handleRemove = (selectedList) => {
//     setSelectedValues(selectedList);
//     handleChange(selectedList);
//   };

//   return (
//     <div
//       tabIndex={0} // Keep div focusable
//       onBlur={() => {
//         if (onBlur) {
//           setTimeout(() => {
//             onBlur(selectedValues); // Ensure latest selected values are passed
//           }, 0);
//         }
//       }}
//     >
//       <div className="d-flex justify-content-between align-items-center">
//         <div className="d-flex gap-5 align-items-center mb-2">
//           {label && (
//             <label className="form-label font-size-14 form-label-custom-visible m-0">
//               {label} {required && <span className="text-danger">*</span>}
//             </label>
//           )}
//         </div>
//         <div className="d-flex gap-5 align-items-center mb-2">
//           <label
//             htmlFor="selectAllCheckbox"
//             className="text-black d-flex align-items-center cursor-pointer"
//           >
//             <input
//               type="checkbox"
//               id="selectAllCheckbox"
//               checked={
//                 selectedValues.length === options.length && options.length > 0
//               }
//               onChange={handleSelectAllToggle}
//               className="me-1"
//             />
//             Select / UnSelect All
//           </label>
//         </div>
//       </div>

//       <Multiselect
//         options={[...options].sort((a, b) =>
//           a[displayValue].localeCompare(b[displayValue])
//         )}
//         selectedValues={selectedValues}
//         onSelect={handleSelect}
//         onRemove={handleRemove}
//         displayValue={displayValue}
//         placeholder={selectedValues?.length > 0 ? "" : placeholder}
//         showCheckbox={showCheckbox}
//         showArrow={true}
//         className={
//           errorMessage && Object?.keys(errorMessage).length > 0
//             ? "multiSelectContainerError"
//             : ""
//         }
//       />

//       {(Array.isArray(errorMessage) || typeof errorMessage === "object") && (
//   <div className="text-danger fw-700 fs-6">
//     {/* Case 1: errorMessage is an array of objects */}
//     {Array.isArray(errorMessage)
//       ? errorMessage
//           .filter((err) =>
//             err?.path?.includes("committees") || err?.context?.key === "committees"
//           )
//           .map((err) => err?.message)
//           .filter(Boolean)
//           .join(" ")

//       // Case 2: errorMessage is an object with field errors
//       : errorMessage?.committees || ""}
//   </div>
// )}

//       {/* {errorMessage && Object?.keys(errorMessage).length > 0 && (
//         <div className="text-danger fw-700 fs-6">
//           {errorMessage &&
//             errorMessage[displayValue] &&
//             errorMessage[displayValue]}
//         </div>
//       )} */}
//     </div>
//   );
// };

// export default MultiSelectDropdown;

import React, { useState, useEffect } from "react";
import Multiselect from "multiselect-react-dropdown";

const MultiSelectDropdown = ({
  name, // ✅ Field name comes from parent
  options = [],
  displayValue = "value",
  placeholder = "Select options",
  showCheckbox = true,
  handleChange,
  label,
  required,
  onBlur,
  errorMessage,
  isClearable = false,
  selectedValue,
  disable = false,
  sortType = "alphabetical", // Days Orderwise display issue solved based on this flag default display alphabetical otherwise given order display
}) => {
  const [selectedValues, setSelectedValues] = useState(selectedValue || []);

  useEffect(() => {
    setSelectedValues(selectedValue || []);
  }, [selectedValue]);

  useEffect(() => {
    handleChange([]);
  }, [isClearable]);

  const handleSelectAllToggle = () => {
    if (selectedValues.length === options.length) {
      handleChange([]);
    } else {
      setSelectedValues(options);
      handleChange(options);
    }
  };

  const handleSelect = (selectedList) => {
    setSelectedValues(selectedList);
    handleChange(selectedList);
  };

  const handleRemove = (selectedList) => {
    setSelectedValues(selectedList);
    handleChange(selectedList);
  };

  // ✅ Error detection for this specific field name
  const hasError = Array.isArray(errorMessage)
    ? errorMessage.some(
        (err) => err?.path?.includes(name) || err?.context?.key === name,
      )
    : Boolean(errorMessage?.[name]);

  const fieldErrorMessage = Array.isArray(errorMessage)
    ? errorMessage
        .filter(
          (err) => err?.path?.includes(name) || err?.context?.key === name,
        )
        .map((err) => err?.message)
        .filter(Boolean)
        .join(" ")
    : errorMessage?.[name] || "";

  const handleKeyDown = () => {
    setTimeout(() => {
      const activeOption = document.querySelector(".highlightOption");

      if (activeOption) {
        activeOption.scrollIntoView({
          block: "nearest",
        });
      }
    }, 0);
  };

  return (
    <div
      tabIndex={0}
      onKeyDown={handleKeyDown}
      onBlur={() => {
        if (onBlur) {
          setTimeout(() => {
            onBlur(selectedValues);
          }, 0);
        }
      }}
    >
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex gap-5 align-items-center white-space-nowrap">
          {label && (
            <label className="form-label font-size-14 form-label-custom-visible m-0">
              {label} {required && <span className="text-danger">*</span>}
            </label>
          )}
        </div>
        <div className="d-flex gap-5 align-items-center white-space-nowrap">
          <label
            htmlFor={`${name}-selectAllCheckbox`}
            className="text-black d-flex align-items-center cursor-pointer"
          >
            <input
              type="checkbox"
              id={`${name}-selectAllCheckbox`}
              checked={
                selectedValues.length === options.length && options.length > 0
              }
              onChange={handleSelectAllToggle}
              className="me-1"
            />
            Select All
          </label>
        </div>
      </div>

      <Multiselect
        // options={[...options].sort((a, b) =>
        //   a[displayValue].localeCompare(b[displayValue])
        // )}
        options={
          sortType === "alphabetical"
            ? [...options].sort((a, b) =>
                a[displayValue].localeCompare(b[displayValue]),
              )
            : [...options] // keep given order
        }
        selectedValues={selectedValues}
        onSelect={handleSelect}
        onRemove={handleRemove}
        // uniqueKey="label"
        displayValue={displayValue}
        placeholder={selectedValues?.length > 0 ? "" : placeholder}
        showCheckbox={showCheckbox}
        showArrow={true}
        className={`bg-white ${hasError ? "multiSelectContainerError" : ""}`}
        closeOnSelect={false}
        disable={disable}
      />

      {hasError && (
        <div className="text-danger fw-700 fs-6">{fieldErrorMessage}</div>
      )}
    </div>
  );
};

export default MultiSelectDropdown;
